import { Filter } from '../../common/filter';
import { boolDialogCtrl } from '../../admin/modals';

require('./filter-card-editor-modal.component.scss');

export class FilterCardEditorModalController {
  constructor(
    $scope,
    FilterResource,
    $modalInstance,
    $modal,
    globalAlert,
    filter,
    CurrentFilterService,
    AlertModalService,
  ) {
    this.$scope = $scope;
    this.$modal = $modal;
    this.FilterResource = FilterResource;
    this.CurrentFilterService = CurrentFilterService;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;
    $scope.filter = angular.copy(filter);

    $scope.ok = () => {
      return $scope.filter.children.reduce((p, f) => {
        return p.then(() => this.saveFilter(f));
      }, this.saveFilter($scope.filter))
        .then(() => {
          $modalInstance.close($scope.filter);
        })
        .catch(error => {
          this.globalAlert(error.message);
        });
    };

    $scope.cancel = () => {
      $modalInstance.dismiss('cancel');
    };

    $scope.delete = () => {
      console.log('Delete filter!');
      $modal.open({
        templateUrl: 'boolDialog.html',
        controller : boolDialogCtrl,
//         message:
      })
        .result
        .then(result => {
          // console.log(result);
          if (result) {
            return FilterResource.delete($scope.filter)
              .then(() => {
                $modalInstance.close(null);
              })
              .catch((error) => {
                globalAlert(error);
              });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  }

  saveFilter(filter) {
    return this.FilterResource.save(filter)
      .then(({status, data}) => {
        if (status === 422) {
          return this.AlertModalService.open(gettext('Ошибка'), gettext(status));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-card-editor-modal.component.js